import {
    Box, Button, Container, Grid, Paper, Popover, Snackbar, Table,
    TableBody, TableContainer, TableHead, TablePagination, Typography
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import {
    ActionMsg, AddButton, Breadcrumb, CustomePopover, DeleteDialog, ExcelDownload,
    HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler
} from "../../reusableComponent/Reusables";

import ReactToPrint from "react-to-print";

import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import maintenance from "../../../services/maintenance";
import HeaderSection from "../../reusableComponent/HeaderSection";
import RmIssuedService from "../../../services/RmIssued.service";

// Print Wrapper
const ComponentToPrintWrapper = ({ quotationPrint }) => {
    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => (
                    <span style={{ display: 'flex', justifyContent: 'center' }}>
                        <PrintOutlinedIcon />
                        <span style={{ marginLeft: '22px' }}>Print Record</span>
                    </span>
                )}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}></div>
        </div>
    );
};

const RmIssuedList = () => {
    const dispatch = useDispatch();
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [sortBy, setSortBy] = useState(null);
    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const totalCount = useSelector(state => state.entry_id?.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.entry_id?.rows_per_page || 15);
    // const rows = useSelector(state => state.entry_id.cylinder_inward)
    const fields = ['customer', 'so_no', 'issued_by', 'approved_by', 'delivery_by', 'total_credit_limit', 'gross_amount'];
    const labels = ['Customer', 'Sales Order No', 'Issued By', 'Approved By', 'Delivery By', 'Total Credit Limit', 'Gross Amount'];
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });

    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await RmIssuedService.getRmIssuedList(params);
            setRows(response);
        } catch (error) {
            setSuccessMessage("Error fetching data");
        }
    };

    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : totalCount,
            searchKey: searchValue,
        };
        try {
            await fetchData(params);
        } catch (error) {
            console.error('Error in handleSearch:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [controller.page, controller.rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController(prev => ({ ...prev, page: newPage }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
    };

    const deleteRecord = async (id) => {
        try {
            await RmIssuedService.editDeleteRmIssued({
                entry_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };

    const handleDelete = (row) => {
        setDeleteInfo(row);
        setIsDelete(true);
    };

    const handleClose = () => {
        setIsDelete(false);
        setDeleteInfo(null);
    };

   
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
 
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });





    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb routeSegments={[{ name: "RM Issued List" },]} />


                <HeaderSection
                    title="RM ISSUED LIST"
                    addNewPath="/productionEntries/AddRmIssu"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="RM Issued List "
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
           
                />



                <TableContainer component={Paper} className={styles.list_tbl_container}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.table_head}`}>Entry Date</StyledTableCell>
                                <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Entry_no</StyledTableCell>
                                <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Issued By</StyledTableCell>
                                  <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Shift</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Shift Time</StyledTableCell>
                                <StyledTableCell align="center" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Action</StyledTableCell>

                            </StyledTableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#fff' }}>
                            {Array.isArray(rows) && rows.map((row, index) => (
                                <StyledTableRow key={row.entry_id || index}>

                                    <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.list_table_body}`}>{row.entry_date}</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.entry_no}</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.issued_by}</StyledTableCell>
                                      <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.shift}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.shift_time}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        <CustomePopover
                                            row={row}
                                            handleDelete={false}
                                            linkTo="/productionEntries/AddRmIssu"
                                              handlePrint ={false}
                                        />
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>



                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.entry_id || null}
                    displayName={deleteInfo?.entry_id || ''}
                />

                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') setSuccessMessage("");
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default RmIssuedList;
